module.exports = __webpack_public_path__ + "static/media/action-logo.4f3c3c5a.png";